export const FAILED_REQUEST = "AUTH_FAILED_REQUEST";
export const LOADING_REQUEST = "AUTH_LOADING_REQUEST";
export const LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";
export const TOGGLE_REMEMBER = "TOGGLE_REMEMBER";
export const SET_HERE_ABOUT_US_STATUS = "SET_HERE_ABOUT_US_STATUS";
export const UPDATE_MODAL_STATUS = "UPDATE_MODAL_STATUS";

export const toggleRememberMe = () => ({
  type: TOGGLE_REMEMBER,
});
